<ng-container *transloco="let t; read: 'user'">
  <div id="assessment-modal" class="rounded-lg fix-action-row modal-body">
    @if (!title) {
      <i  mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle ml-auto"></i>
    }

    @if (title) {
      <div class="flex justify-between border-b">
        @if (title) {
          <!-- Title is supplied by the component that opens this dialog. -->
          <h1 class="text-[25px] font-bold">{{title}}</h1>
        }
        <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle ml-auto"></i>
      </div>
    }

    <div mat-dialog-content>
      @if (customMessage) {
        <!-- Message is supplied by the component that opens this dialog. -->
        <p class="mt-2">{{ customMessage }}</p>
      } @else {
        <p class="text-lg"> {{ t('inputRating.assessmentDateModal.confirmPrompt') }} </p>
      }

      <div class="relative">
        <mat-form-field appearance="fill">
          <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate" [max]="today" [placeholder]="'shared.datePicker.placeholder' | transloco">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <div class="absolute top-0 left-full mt-4 ml-[-2px]">
          <i class="uil uil-info-circle text-xs" [matTooltip]="t('inputRating.assessmentDateModal.dateInfoTooltip')"></i>
        </div>
      </div>

    </div>
    <div mat-dialog-actions class="flex justify-end align-bottom">
      <div class="flex justify-end align-bottom">
        <drdp-btn color="cancel" class="mr-2" mat-button mat-dialog-close>{{ t('inputRating.common.cancel') }}</drdp-btn>
        <drdp-btn color="save" class="mr-2" (click)="onSubmit()">{{ t('inputRating.assessmentDateModal.confirmButton') }}</drdp-btn>
      </div>
    </div>
  </div>
</ng-container>
